import { render } from "./UserInsights.vue?vue&type=template&id=7d9f186c&scoped=true"
import script from "./UserInsights.vue?vue&type=script&lang=js"
export * from "./UserInsights.vue?vue&type=script&lang=js"

import "./UserInsights.vue?vue&type=style&index=0&id=7d9f186c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9f186c"]])

export default __exports__